import $ from 'jquery';

class PlausibleCustomAnalytics {
    constructor () {
        this.$download = $('.js-download');

        this.$download.on('click', (e) => {
            this.plausibleEvent(e);
        });
    }

    // eslint-disable-next-line class-methods-use-this
    plausibleEvent (e) {
        const $elem = $(e.currentTarget);
        plausible('Download', {props: {file: $elem.attr('href')}});
    }
}

export default PlausibleCustomAnalytics;
